import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {environment} from 'src/environments/environment';
import { searchCollections } from '../classes/search-collections';
import { imageTypeCode } from '../classes/image-type';
// import {Settings} from './app.settings';

export class Data {
    constructor(public totalPrice: number,
                public totalCartCount: number,
                public discount: number,
                public compareList: any[] = [],
                public wishList: any[] = [],
                public cartList: any[] = [],
                public orderList: any[] = [],
                public categories: any[] = [],
                public user: any = null) {
    }
}

@Injectable({
    providedIn: 'root'
})
export class BudgetService {
    public taxPercentage = 0.18;
    public Data = new Data(0,0,0);
    public url = '';


    // public searchApiUrl = 'http://beta.api.indiapicture.in/search.ibudgetphoto-new.php';
    public searchApiUrl = environment.searchIndiapictureBudgetApiurl;
    public searchhintUrl = environment.searchhint;
    public backendUrl = environment.budgetBackendUrl;
    public similarApiurl = environment.similarIndiapictureBudgetUrl;
    public contributorApiUrl = environment.contributorApiUrl;

    constructor(public http: HttpClient, public snackBar: MatSnackBar) {
        if (document.location.hostname != 'localhost') {
            this.url = document.location.protocol + '//' + document.location.hostname + '/assets/data/';
        } else {
            this.url = environment.budgetBackendUrl + 'assets/data/';
        }
    }

    public getCategories(): Observable<any> {
        return this.http.get<any>(this.url + 'categories.json');
    }

    // BUDGET users read categories from the app's own static assets
    // (e.g. http://localhost:4200/assets/data/budget-categories.json),
    // not from the budget backend.
    public getBudgetCategories(): Observable<any> {
        return this.http.get<any>('assets/data/budget-categories.json');
    }

    public getanys(type): Observable<any> {
        return this.http.get<any>(this.url + type + '-anys.json');
    }

    public getanyById(id): Observable<any> {
        return this.http.get<any>(this.url + 'any-' + id + '.json');
    }

    public getBanners(): Observable<any[]> {
        return this.http.get<any[]>(this.url + 'banners.json');
    }


    public resetanyCartCount(any:any) {
        any.cartCount = 0;
        const compareany = this.Data.compareList.filter((item:any) => item.id == any.id)[0];
        if (compareany) {
            compareany.cartCount = 0;
        }
        const wishany = this.Data.wishList.filter((item:any) => item.id == any.id)[0];
        if (wishany) {
            wishany.cartCount = 0;
        }
    }

    public getBrands() {
        return [
            {name: 'aloha', image: 'assets/images/brands/aloha.png'},
            {name: 'dream', image: 'assets/images/brands/dream.png'},
            {name: 'congrats', image: 'assets/images/brands/congrats.png'},
            {name: 'best', image: 'assets/images/brands/best.png'},
            {name: 'original', image: 'assets/images/brands/original.png'},
            {name: 'retro', image: 'assets/images/brands/retro.png'},
            {name: 'king', image: 'assets/images/brands/king.png'},
            {name: 'love', image: 'assets/images/brands/love.png'},
            {name: 'the', image: 'assets/images/brands/the.png'},
            {name: 'easter', image: 'assets/images/brands/easter.png'},
            {name: 'with', image: 'assets/images/brands/with.png'},
            {name: 'special', image: 'assets/images/brands/special.png'},
            {name: 'bravo', image: 'assets/images/brands/bravo.png'}
        ];
    }

    public getCountries() {
        return [
            {name: 'Afghanistan', code: 'AF'},
            {name: 'Aland Islands', code: 'AX'},
            {name: 'Albania', code: 'AL'},
            {name: 'Algeria', code: 'DZ'},
            {name: 'American Samoa', code: 'AS'},
            {name: 'AndorrA', code: 'AD'},
            {name: 'Angola', code: 'AO'},
            {name: 'Anguilla', code: 'AI'},
            {name: 'Antarctica', code: 'AQ'},
            {name: 'Antigua and Barbuda', code: 'AG'},
            {name: 'Argentina', code: 'AR'},
            {name: 'Armenia', code: 'AM'},
            {name: 'Aruba', code: 'AW'},
            {name: 'Australia', code: 'AU'},
            {name: 'Austria', code: 'AT'},
            {name: 'Azerbaijan', code: 'AZ'},
            {name: 'Bahamas', code: 'BS'},
            {name: 'Bahrain', code: 'BH'},
            {name: 'Bangladesh', code: 'BD'},
            {name: 'Barbados', code: 'BB'},
            {name: 'Belarus', code: 'BY'},
            {name: 'Belgium', code: 'BE'},
            {name: 'Belize', code: 'BZ'},
            {name: 'Benin', code: 'BJ'},
            {name: 'Bermuda', code: 'BM'},
            {name: 'Bhutan', code: 'BT'},
            {name: 'Bolivia', code: 'BO'},
            {name: 'Bosnia and Herzegovina', code: 'BA'},
            {name: 'Botswana', code: 'BW'},
            {name: 'Bouvet Island', code: 'BV'},
            {name: 'Brazil', code: 'BR'},
            {name: 'British Indian Ocean Territory', code: 'IO'},
            {name: 'Brunei Darussalam', code: 'BN'},
            {name: 'Bulgaria', code: 'BG'},
            {name: 'Burkina Faso', code: 'BF'},
            {name: 'Burundi', code: 'BI'},
            {name: 'Cambodia', code: 'KH'},
            {name: 'Cameroon', code: 'CM'},
            {name: 'Canada', code: 'CA'},
            {name: 'Cape Verde', code: 'CV'},
            {name: 'Cayman Islands', code: 'KY'},
            {name: 'Central African Republic', code: 'CF'},
            {name: 'Chad', code: 'TD'},
            {name: 'Chile', code: 'CL'},
            {name: 'China', code: 'CN'},
            {name: 'Christmas Island', code: 'CX'},
            {name: 'Cocos (Keeling) Islands', code: 'CC'},
            {name: 'Colombia', code: 'CO'},
            {name: 'Comoros', code: 'KM'},
            {name: 'Congo', code: 'CG'},
            {name: 'Congo, The Democratic Republic of the', code: 'CD'},
            {name: 'Cook Islands', code: 'CK'},
            {name: 'Costa Rica', code: 'CR'},
            {name: 'Cote D\'Ivoire', code: 'CI'},
            {name: 'Croatia', code: 'HR'},
            {name: 'Cuba', code: 'CU'},
            {name: 'Cyprus', code: 'CY'},
            {name: 'Czech Republic', code: 'CZ'},
            {name: 'Denmark', code: 'DK'},
            {name: 'Djibouti', code: 'DJ'},
            {name: 'Dominica', code: 'DM'},
            {name: 'Dominican Republic', code: 'DO'},
            {name: 'Ecuador', code: 'EC'},
            {name: 'Egypt', code: 'EG'},
            {name: 'El Salvador', code: 'SV'},
            {name: 'Equatorial Guinea', code: 'GQ'},
            {name: 'Eritrea', code: 'ER'},
            {name: 'Estonia', code: 'EE'},
            {name: 'Ethiopia', code: 'ET'},
            {name: 'Falkland Islands (Malvinas)', code: 'FK'},
            {name: 'Faroe Islands', code: 'FO'},
            {name: 'Fiji', code: 'FJ'},
            {name: 'Finland', code: 'FI'},
            {name: 'France', code: 'FR'},
            {name: 'French Guiana', code: 'GF'},
            {name: 'French Polynesia', code: 'PF'},
            {name: 'French Southern Territories', code: 'TF'},
            {name: 'Gabon', code: 'GA'},
            {name: 'Gambia', code: 'GM'},
            {name: 'Georgia', code: 'GE'},
            {name: 'Germany', code: 'DE'},
            {name: 'Ghana', code: 'GH'},
            {name: 'Gibraltar', code: 'GI'},
            {name: 'Greece', code: 'GR'},
            {name: 'Greenland', code: 'GL'},
            {name: 'Grenada', code: 'GD'},
            {name: 'Guadeloupe', code: 'GP'},
            {name: 'Guam', code: 'GU'},
            {name: 'Guatemala', code: 'GT'},
            {name: 'Guernsey', code: 'GG'},
            {name: 'Guinea', code: 'GN'},
            {name: 'Guinea-Bissau', code: 'GW'},
            {name: 'Guyana', code: 'GY'},
            {name: 'Haiti', code: 'HT'},
            {name: 'Heard Island and Mcdonald Islands', code: 'HM'},
            {name: 'Holy See (Vatican City State)', code: 'VA'},
            {name: 'Honduras', code: 'HN'},
            {name: 'Hong Kong', code: 'HK'},
            {name: 'Hungary', code: 'HU'},
            {name: 'Iceland', code: 'IS'},
            {name: 'India', code: 'IN'},
            {name: 'Indonesia', code: 'ID'},
            {name: 'Iran, Islamic Republic Of', code: 'IR'},
            {name: 'Iraq', code: 'IQ'},
            {name: 'Ireland', code: 'IE'},
            {name: 'Isle of Man', code: 'IM'},
            {name: 'Israel', code: 'IL'},
            {name: 'Italy', code: 'IT'},
            {name: 'Jamaica', code: 'JM'},
            {name: 'Japan', code: 'JP'},
            {name: 'Jersey', code: 'JE'},
            {name: 'Jordan', code: 'JO'},
            {name: 'Kazakhstan', code: 'KZ'},
            {name: 'Kenya', code: 'KE'},
            {name: 'Kiribati', code: 'KI'},
            {name: 'Korea, Democratic People\'S Republic of', code: 'KP'},
            {name: 'Korea, Republic of', code: 'KR'},
            {name: 'Kuwait', code: 'KW'},
            {name: 'Kyrgyzstan', code: 'KG'},
            {name: 'Lao People\'S Democratic Republic', code: 'LA'},
            {name: 'Latvia', code: 'LV'},
            {name: 'Lebanon', code: 'LB'},
            {name: 'Lesotho', code: 'LS'},
            {name: 'Liberia', code: 'LR'},
            {name: 'Libyan Arab Jamahiriya', code: 'LY'},
            {name: 'Liechtenstein', code: 'LI'},
            {name: 'Lithuania', code: 'LT'},
            {name: 'Luxembourg', code: 'LU'},
            {name: 'Macao', code: 'MO'},
            {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
            {name: 'Madagascar', code: 'MG'},
            {name: 'Malawi', code: 'MW'},
            {name: 'Malaysia', code: 'MY'},
            {name: 'Maldives', code: 'MV'},
            {name: 'Mali', code: 'ML'},
            {name: 'Malta', code: 'MT'},
            {name: 'Marshall Islands', code: 'MH'},
            {name: 'Martinique', code: 'MQ'},
            {name: 'Mauritania', code: 'MR'},
            {name: 'Mauritius', code: 'MU'},
            {name: 'Mayotte', code: 'YT'},
            {name: 'Mexico', code: 'MX'},
            {name: 'Micronesia, Federated States of', code: 'FM'},
            {name: 'Moldova, Republic of', code: 'MD'},
            {name: 'Monaco', code: 'MC'},
            {name: 'Mongolia', code: 'MN'},
            {name: 'Montserrat', code: 'MS'},
            {name: 'Morocco', code: 'MA'},
            {name: 'Mozambique', code: 'MZ'},
            {name: 'Myanmar', code: 'MM'},
            {name: 'Namibia', code: 'NA'},
            {name: 'Nauru', code: 'NR'},
            {name: 'Nepal', code: 'NP'},
            {name: 'Netherlands', code: 'NL'},
            {name: 'Netherlands Antilles', code: 'AN'},
            {name: 'New Caledonia', code: 'NC'},
            {name: 'New Zealand', code: 'NZ'},
            {name: 'Nicaragua', code: 'NI'},
            {name: 'Niger', code: 'NE'},
            {name: 'Nigeria', code: 'NG'},
            {name: 'Niue', code: 'NU'},
            {name: 'Norfolk Island', code: 'NF'},
            {name: 'Northern Mariana Islands', code: 'MP'},
            {name: 'Norway', code: 'NO'},
            {name: 'Oman', code: 'OM'},
            {name: 'Pakistan', code: 'PK'},
            {name: 'Palau', code: 'PW'},
            {name: 'Palestinian Territory, Occupied', code: 'PS'},
            {name: 'Panama', code: 'PA'},
            {name: 'Papua New Guinea', code: 'PG'},
            {name: 'Paraguay', code: 'PY'},
            {name: 'Peru', code: 'PE'},
            {name: 'Philippines', code: 'PH'},
            {name: 'Pitcairn', code: 'PN'},
            {name: 'Poland', code: 'PL'},
            {name: 'Portugal', code: 'PT'},
            {name: 'Puerto Rico', code: 'PR'},
            {name: 'Qatar', code: 'QA'},
            {name: 'Reunion', code: 'RE'},
            {name: 'Romania', code: 'RO'},
            {name: 'Russian Federation', code: 'RU'},
            {name: 'RWANDA', code: 'RW'},
            {name: 'Saint Helena', code: 'SH'},
            {name: 'Saint Kitts and Nevis', code: 'KN'},
            {name: 'Saint Lucia', code: 'LC'},
            {name: 'Saint Pierre and Miquelon', code: 'PM'},
            {name: 'Saint Vincent and the Grenadines', code: 'VC'},
            {name: 'Samoa', code: 'WS'},
            {name: 'San Marino', code: 'SM'},
            {name: 'Sao Tome and Principe', code: 'ST'},
            {name: 'Saudi Arabia', code: 'SA'},
            {name: 'Senegal', code: 'SN'},
            {name: 'Serbia and Montenegro', code: 'CS'},
            {name: 'Seychelles', code: 'SC'},
            {name: 'Sierra Leone', code: 'SL'},
            {name: 'Singapore', code: 'SG'},
            {name: 'Slovakia', code: 'SK'},
            {name: 'Slovenia', code: 'SI'},
            {name: 'Solomon Islands', code: 'SB'},
            {name: 'Somalia', code: 'SO'},
            {name: 'South Africa', code: 'ZA'},
            {name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
            {name: 'Spain', code: 'ES'},
            {name: 'Sri Lanka', code: 'LK'},
            {name: 'Sudan', code: 'SD'},
            {name: 'Suriname', code: 'SR'},
            {name: 'Svalbard and Jan Mayen', code: 'SJ'},
            {name: 'Swaziland', code: 'SZ'},
            {name: 'Sweden', code: 'SE'},
            {name: 'Switzerland', code: 'CH'},
            {name: 'Syrian Arab Republic', code: 'SY'},
            {name: 'Taiwan, Province of China', code: 'TW'},
            {name: 'Tajikistan', code: 'TJ'},
            {name: 'Tanzania, United Republic of', code: 'TZ'},
            {name: 'Thailand', code: 'TH'},
            {name: 'Timor-Leste', code: 'TL'},
            {name: 'Togo', code: 'TG'},
            {name: 'Tokelau', code: 'TK'},
            {name: 'Tonga', code: 'TO'},
            {name: 'Trinidad and Tobago', code: 'TT'},
            {name: 'Tunisia', code: 'TN'},
            {name: 'Turkey', code: 'TR'},
            {name: 'Turkmenistan', code: 'TM'},
            {name: 'Turks and Caicos Islands', code: 'TC'},
            {name: 'Tuvalu', code: 'TV'},
            {name: 'Uganda', code: 'UG'},
            {name: 'Ukraine', code: 'UA'},
            {name: 'United Arab Emirates', code: 'AE'},
            {name: 'United Kingdom', code: 'GB'},
            {name: 'United States', code: 'US'},
            {name: 'United States Minor Outlying Islands', code: 'UM'},
            {name: 'Uruguay', code: 'UY'},
            {name: 'Uzbekistan', code: 'UZ'},
            {name: 'Vanuatu', code: 'VU'},
            {name: 'Venezuela', code: 'VE'},
            {name: 'Viet Nam', code: 'VN'},
            {name: 'Virgin Islands, British', code: 'VG'},
            {name: 'Virgin Islands, U.S.', code: 'VI'},
            {name: 'Wallis and Futuna', code: 'WF'},
            {name: 'Western Sahara', code: 'EH'},
            {name: 'Yemen', code: 'YE'},
            {name: 'Zambia', code: 'ZM'},
            {name: 'Zimbabwe', code: 'ZW'}
        ];
    }

    public getMonths() {
        return [
            {value: '01', name: 'January'},
            {value: '02', name: 'February'},
            {value: '03', name: 'March'},
            {value: '04', name: 'April'},
            {value: '05', name: 'May'},
            {value: '06', name: 'June'},
            {value: '07', name: 'July'},
            {value: '08', name: 'August'},
            {value: '09', name: 'September'},
            {value: '10', name: 'October'},
            {value: '11', name: 'November'},
            {value: '12', name: 'December'}
        ];
    }

    public getYears() {
        return ['2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030'];
    }

    public getDeliveryMethods() {
        return [
            {value: 'free', name: 'Free Delivery', desc: '$0.00 / Delivery in 7 to 14 business Days'},
            {value: 'standard', name: 'Standard Delivery', desc: '$7.99 / Delivery in 5 to 7 business Days'},
            {value: 'express', name: 'Express Delivery', desc: '$29.99 / Delivery in 1 business Days'}
        ];
    }


    /* New code added */

    public getCustomerAddress() {
        return this.http.post<any>(this.backendUrl + 'receiptImages', {});
    }

    public addToCartListDB(image: string, customer_id: string) {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<any>(this.backendUrl + 'cartlist', {customer_id, image}, httpOptions);
    }

    /* Custom Methods added */
    public getImages(text, noOfImages, page, filter, skipLoader, coll_id = ''): Observable<any> {
        // This one sent no coll_id at all, so it searched a different library
        // from the other four for the same words.
        const collections = searchCollections(coll_id);

        // search-exclusive-new.php's image-type code. The search page puts its own
        // in `filter`; every other caller (similar images, related) gets null.
        const imageType = String(filter || '').indexOf('imageType=') === -1
            ? '&imageType=' + imageTypeCode(null)
            : '';

        return this.http.get<any>(this.searchApiUrl + '?searchtext=' + text + '&images='
            + noOfImages + '&page=' + page + '' + filter + imageType + '&coll_id=' + collections, {
            params: {skipLoader}
        });
    }

    public getSimilarImages(text, noOfImages, page, collection, related, skipLoader): Observable<any> {
        return this.http.get<any>(this.similarApiurl + '?searchtext=' + text + '&images='
            + noOfImages + '&page=' + page + '&collection=' + collection + '&related_type=' + related, {
            params: {skipLoader}
        });
    }

    public getGalleryImages(id, noOfImages, page, skipLoader): Observable<any[]> {
        return this.http.get<any[]>(this.contributorApiUrl  + '/getCollectionImagesPagination?id=' + id + '&images='
            + noOfImages + '&page=' + page , {
            params: {skipLoader}
        });
    }

    public forgotPassword(email: string) {
        return this.http.get<any>(this.backendUrl + 'auth/resetPassword?email=' + email);
    }

    public signIn(email, password): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'auth/loginCustomer', {email, password});
    }

    public register(name, email, phone, password): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'auth/register', {name, email, phone, password});
    }

    public verifyCaptcha(captchaResponse): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'auth/verifyCaptcha', {captchaResponse});
    }

    public updateProfile(firstname, lastname, email, company, com_type, job_desc, address, state, pincode, city, phone, fax, user_id): Observable<any> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<any>(this.backendUrl + 'updateProfile', {
            firstname,
            lastname,
            email,
            company,
            com_type,
            job_desc,
            address,
            state,
            pincode,
            city,
            phone,
            fax,
            user_id
        }, httpOptions);
    }

    public getUserDetail(email): Observable<any> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<any>(this.backendUrl + 'getUserDetail', {email}, httpOptions);
    }

    public changePassword(email, new_pass, current_pass, encrypted_pass, is_encrypted): Observable<any> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<any>(this.backendUrl + 'auth/changePassword', {
            email,
            new_pass,
            current_pass,
            encrypted_pass,
            is_encrypted
        }, httpOptions);
    }

    public logout(): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'logout', {});
    }

    public settings(): Observable<any> {
        return this.http.get<any>(this.backendUrl + 'setting', {});
    }

    public getImageById(id, collection, imageType): Observable<any> {
        return this.http.get<any>(this.backendUrl + 'auth/singleImageDetail?imageId=' + id + '&collection=' + collection + '&type=' + imageType);
    }

    public addContact(name: string, email: string, mobile: string, message: string) {
        return this.http.post<any>(this.backendUrl + 'auth/contact', {name, email, mobile, message});
    }

    public pageView(page_url: string, is_plan_page = 0): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'auth/page-view', {page_url, is_plan_page});
    }

    public addOnDemandContact(name: string, email: string, mobile: string, message: string) {
        return this.http.post<any>(this.backendUrl + 'auth/onDemandcontact', {name, email, mobile, message});
    }

    public addSubscribe(email: string) {
        return this.http.post<any>(this.backendUrl + 'auth/subscribe', {email});
    }


    public getWishList(customer_id): Observable<any> {
        return this.http.get<any>(this.backendUrl + 'wishlist?customer_id=' + customer_id);
    }

    public getWishListById(id): Observable<any> {
        return this.http.get<any>(this.backendUrl + 'wishlist/' + id);
    }

    public getWishListByToken(token): Observable<any> {
        return this.http.get<any>(this.backendUrl + 'auth/wishlist-token/' + token);
    }

    public addToWishListDB(image: string, name: string, customer_id: string) {
        return this.http.post<any>(this.backendUrl + 'wishlist', {customer_id, name, image});
    }

    public updateToWishListDB(image: string, id: number, isDelete: boolean) {
        return this.http.put<any>(this.backendUrl + 'wishlist', {id, image, isDelete});
    }

    public removeWishList(id: number) {
        return this.http.delete<any>(this.backendUrl + 'wishlist?id=' + id);
    }

    public shareLightbox(email: string, id: number, send_email: number) {
        return this.http.post<any>(this.backendUrl + 'share-lightbox', {email, id, send_email});
    }

    public addToCart(any: any, totalPrice: number, totalCartCount: number) {
        let message, status;
        this.Data.totalPrice = totalPrice;
        this.Data.totalCartCount = totalCartCount;
        this.Data.cartList = any;
    }

    public getCartList(customer_id: string) {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.get<any>(this.backendUrl + 'cartlist?customer_id=' + customer_id, httpOptions);
    }

    public removeCartList(customer_id: string) {
        return this.http.delete<any>(this.backendUrl + 'cartlist?customer_id=' + customer_id);
    }

    public removeCartProduct(image: string, customer_id: string) {
        return this.http.post<any>(this.backendUrl + 'cartProduct', {customer_id, image});
    }

    public getSubscriptionDetail(collection: string, image_id: string, license: string, type: string) {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<any>(this.backendUrl + 'subscription-detail', {
            collection,
            image_id,
            license,
            type
        }, httpOptions);
    }

    public getDownloadVideoDetail(category: string, collection: string, video_id: string, license: string) {
        return this.http.post<any>(this.backendUrl + 'download-video-detail', {
            category,
            collection,
            video_id,
            license
        });
    }

    public downloadImage(imageData: any, type: boolean): Observable<any> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<any>(this.backendUrl + 'download', {imageData, type}, httpOptions);
    }

    public reDownloadImage(id: number): Observable<string> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<string>(this.backendUrl + 'reDownloadImage', {id}, httpOptions);
    }

    // Re-download an IndiaPicture image for a budget user (IP section).
    public reDownloadImageIp(id: number): Observable<any> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<any>(this.backendUrl + 'reDownloadImageIp', {id}, httpOptions);
    }

    public reDownloadImageById(imageData: any, type: boolean): Observable<string> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<string>(this.backendUrl + 'reDownloadImageById', {imageData, type}, httpOptions);
    }


    public downloadVideo(imageData: any, type: boolean): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'download-video', {imageData, type});
    }

    public downloadSalesImage(imageData: any, type: boolean): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'download-sales-image', {imageData});
    }

    public downloadSalesVideo(imageData: any): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'download-sales-video', {imageData});
    }

    public generateOrder(user: any) {
        return this.http.post<any>(this.backendUrl + 'generateOrder', {user});
    }

    public generatePackage(user: any, package_id, promo_id, discount, free_item) {
        return this.http.post<any>(this.backendUrl + 'generatePackage', {user, package_id, promo_id, discount, free_item});
    }

    public compDownload(imageData: any): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'comp-download', {imageData});
    }

    public getOrders(customer_id: string) {
        return this.http.get<any>(this.backendUrl + 'order?customer_id=' + customer_id);
    }

    public getPackageHistory(customer_id: string) {
        return this.http.get<any>(this.backendUrl + 'package-history?customer_id=' + customer_id);
    }

    public getOrdersSingle(customer_id: string, type: string) {
        return this.http.get<any[]>(this.backendUrl + 'orderSingle?customer_id=' + customer_id + '&type=' + type);
    }

    public getSalesDownload(customer_id: string) {
        return this.http.get<any[]>(this.backendUrl + 'sales-download?customer_id=' + customer_id);
    }

    public getCompType() {
        return [
            {name: 'Advertising Agency', code: '1'},
            {name: 'Corporation', code: '2'},
            {name: 'Education/Government', code: '10'},
            {name: 'Film Studio', code: '3'},
            {name: 'Freelance/Consultant', code: '4'},
            {name: 'Graphic Design Company', code: '5'},
            {name: 'Home Office', code: '6'},
            {name: 'In-house Creative Group', code: '8'},
            {name: 'Marketing Communications', code: '7'},
            {name: 'Non-profit/Cultural Institution', code: '9'},
            {name: 'anyion/Post-anyion Company', code: '11'},
            {name: 'Publisher-Book', code: '15'},
            {name: 'Publisher-Internet', code: '18'},
            {name: 'Publisher-Magazine', code: '12'},
            {name: 'Publisher-Newspaper', code: '19'},
            {name: 'Sports Body', code: '16'},
            {name: 'Sport Sponsor', code: '17'},
            {name: 'Television Network', code: '13'},
            {name: 'Other', code: '14'}
        ];
    }

    public getJobDesc() {
        return [
            {name: 'Account Executive', code: '1'},
            {name: 'Art Buyer', code: '3'},
            {name: 'Art Director/Creative Director', code: '4'},
            {name: 'Designer', code: '5'},
            {name: 'Film/Video Editor', code: '6'},
            {name: 'Freelance/Consultant', code: '7'},
            {name: 'Manager/Administrator', code: '2'},
            {name: 'Photo Editor', code: '15'},
            {name: 'Photo/Film Researcher', code: '9'},
            {name: 'Photographer', code: '8'},
            {name: 'Producer', code: '11'},
            {name: 'anyion/Post-anyion', code: '10'},
            {name: 'Student/Educator/Trainer', code: '12'},
            {name: 'Writer/Copywriter/Editor', code: '13'},
            {name: 'Other', code: '14'}
        ];
    }

    public getStates() {
        return [{code: 'AN', name: 'Andaman and Nicobar Islands'},
            {code: 'AP', name: 'Andhra Pradesh'},
            {code: 'AR', name: 'Arunachal Pradesh'},
            {code: 'AS', name: 'Assam'},
            {code: 'BR', name: 'Bihar'},
            {code: 'CG', name: 'Chandigarh'},
            {code: 'CH', name: 'Chhattisgarh'},
            {code: 'DH', name: 'Dadra and Nagar Haveli'},
            {code: 'DD', name: 'Daman and Diu'},
            {code: 'DL', name: 'Delhi'},
            {code: 'GA', name: 'Goa'},
            {code: 'GJ', name: 'Gujarat'},
            {code: 'HR', name: 'Haryana'},
            {code: 'HP', name: 'Himachal Pradesh'},
            {code: 'JK', name: 'Jammu and Kashmir'},
            {code: 'JH', name: 'Jharkhand'},
            {code: 'KA', name: 'Karnataka'},
            {code: 'KL', name: 'Kerala'},
            {code: 'LD', name: 'Lakshadweep'},
            {code: 'MP', name: 'Madhya Pradesh'},
            {code: 'MH', name: 'Maharashtra'},
            {code: 'MN', name: 'Manipur'},
            {code: 'ML', name: 'Meghalaya'},
            {code: 'MZ', name: 'Mizoram'},
            {code: 'NL', name: 'Nagaland'},
            {code: 'OR', name: 'Odisha'},
            {code: 'PY', name: 'Puducherry'},
            {code: 'PB', name: 'Punjab'},
            {code: 'RJ', name: 'Rajasthan'},
            {code: 'SK', name: 'Sikkim'},
            {code: 'TN', name: 'Tamil Nadu'},
            {code: 'TS', name: 'Telangana'},
            {code: 'TR', name: 'Tripura'},
            {code: 'UK', name: 'Uttarakhand'},
            {code: 'UP', name: 'Uttar Pradesh'},
            {code: 'WB', name: 'West Bengal'}];
    }

    public getReceipt(customerPackageId: number): Observable<any> {
        return this.http.post<any>(this.backendUrl + 'receipt', {customerPackageId});
    }

    public downloadFile(data: any) {
        const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
        const header = Object.keys(data[0]);
        const csv = data.map((row:any) =>
            header
                .map((fieldName) => JSON.stringify(row[fieldName], replacer))
                .join(',')
        );
        csv.unshift(header.join(','));
        return csv.join('\r\n');
    }

    public addQueryForm(element: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain'
            })
        };
        return this.http.post<any>(this.backendUrl + 'auth/query-form', element, httpOptions);
    }

    public getRegionsContact() {
        return [
            {
                id: 4,
                region: 'EAST',
                contact: '(+91) 9871913105',
                email: 'gaurav@indiapicture.in'
            },
            {
                id: 2,
                region: 'WEST',
                contact: '(+91) 99110 82058',
                email: 'rahul@indiapicture.in'
            },
            {
                id: 1,
                region: 'NORTH',
                contact: '(+91) 9871954443',
                email: 'rajesh@indiapicture.in'
            },
            {
                id: 3,
                region: 'SOUTH',
                contact: '(+91) 9871913105',
                email: 'teamsouth@indiapicture.in'
            },
            {
                id: 13,
                region: 'EDITORIAL',
                contact: '(+91) 9599801596',
                email: 'editorial@indiapicture.in'
            },
            {
                id: 24,
                region: 'ONLINE AD',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 19,
                region: 'ONLINE EAST',
                contact: '(+91) 9871954443',
                email: 'rajesh@indiapicture.in'
            },
            {
                id: 20,
                region: 'ONLINE WEST',
                contact: '(+91) 9871954443',
                email: 'rajesh@indiapicture.in'
            },
            {
                id: 22,
                region: 'ONLINE NORTH',
                contact: '(+91) 9871954443',
                email: 'rajesh@indiapicture.in'
            },
            {
                id: 21,
                region: 'ONLINE SOUTH',
                contact: '(+91) 9871954443',
                email: 'rajesh@indiapicture.in'
            },
            {
                id: 23,
                region: 'ONLINE OTHERS',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 5,
                region: 'OTHERS',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 6,
                region: 'PAKISTAN',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 7,
                region: 'SRI LANKA',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 8,
                region: 'BANGLADESH',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 9,
                region: 'UK/EUROPE/AFRICA',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 10,
                region: 'USA',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 11,
                region: 'RUSSIA',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 18,
                region: 'MART',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 14,
                region: 'FOR LEGAL',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 15,
                region: 'BUDGET PHOTO',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 16,
                region: 'ADJUSTMENT',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            },
            {
                id: 17,
                region: 'ADJUSTMENT FOR NORTH',
                contact: '(+91) 9599801596',
                email: 'care@indiapicture.in'
            }
        ];
    }

    public getPackageList() {
        return this.http.get<any[]>(this.backendUrl + 'auth/getPackagesUnauth');
    }

    public getPackageDetail(id: number) {
        return this.http.get<any>(this.backendUrl + 'package/' + id);
    }

    public getSearchHint(text, skipLoader): Observable<any> {
        return this.http.get<any>(this.searchhintUrl + '?searchText=' + text, {
            params: {skipLoader}
        });
    }

    public applyPromo(promo_code: string) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain'
            })
        };
        return this.http.post<any>(this.backendUrl + 'applyPromo', {promo_code}, httpOptions);
    }

    public getCustomerPackageFront(pageNumber: number, pageSize: number): Observable<any> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            }),
            params: {
                mode: 'list',
                is_active: '1',
                package_type: 'Subscription',
                sortBy: 'activated_at',
                sortOrder: 'desc',
                pageNumber: String(pageNumber),
                pageSize: String(pageSize)
            }
        };
        return this.http.get<any>(this.backendUrl + 'customer-package-front', httpOptions);
    }

    public getDownloadHistory(type: string, pageNumber: number, pageSize: number,
                              filters: { from_date?: string; to_date?: string; image_id?: string } = {}): Observable<any> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            }),
            params: {
                mode: 'list',
                type,
                sortBy: 'created_at',
                sortOrder: 'desc',
                pageNumber: String(pageNumber),
                pageSize: String(pageSize),
                from_date: filters.from_date || '',
                to_date: filters.to_date || '',
                image_id: filters.image_id || ''
            }
        };
        return this.http.get<any>(this.backendUrl + 'download-history', httpOptions);
    }

    // IndiaPicture download history for a budget user (IP customer_download via budget proxy).
    public getDownloadHistoryIp(customer_id: string, type: string, page: number,
                                filters: { from_date?: string; to_date?: string; image_id?: string } = {}): Observable<any> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.get<any>(this.backendUrl + 'download-history-ip?customer_id=' + customer_id
            + '&type=' + type + '&page=' + page
            + '&from_date=' + (filters.from_date || '') + '&to_date=' + (filters.to_date || '')
            + '&image_id=' + (filters.image_id || ''), httpOptions);
    }

    public getCustomerPackageFrontIp(customer_id: string): Observable<any> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.get<any>(this.backendUrl + 'customer-package-front-ip?customer_id=' + customer_id, httpOptions);
    }

    public getAccountDashboardData() {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.get<any>(this.backendUrl + 'accountDashboardData', httpOptions);
    }

    public addPageView(page_url: string, is_plan_page: number) {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const token = currentUser?.token || '';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*',
                Authorization: token ? `Bearer ${token}` : ''
            })
        };
        return this.http.post<any>(this.backendUrl + 'auth/page-view', {page_url, is_plan_page}, httpOptions);
    }

    public addClickToEnlarge(image: string) {
        return this.http.post<any>(this.backendUrl + 'auth/clickToEnlarge', {image});
    }

    addContest(element: any): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain'
            })
        };

        return this.http.post<any>(this.backendUrl + 'auth/contest', element, httpOptions);
    }

    // ************************************
   
   
public createCashfreeOrder(data: {
  id: number;
  amount: number;
  customer_id: string;
  customer_email: string;
  customer_name: string;
  customer_phone: string;
}): Observable<{ payment_session_id: string; order_id: string }> {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    })
  };

  return this.http.post<{ payment_session_id: string; order_id: string }>(
    `${this.backendUrl}auth/cashfree/create-order`,
    data,
    httpOptions
  );
}

public initiateCashfreePayment(paymentSessionId: string): void {
  // Load Cashfree.js dynamically
  const script = document.createElement('script');
  script.src = 'https://sdk.cashfree.com/js/v3/cashfree.js';
  script.onload = () => {
    const cashfree = new (window as any).Cashfree();
    cashfree.checkout({
      paymentSessionId: paymentSessionId,
      redirectTarget: '_self'
    });
  };
  document.body.appendChild(script);
}
    // ***********************************

    // ************cart*********
    // And add this service method to your appService:
public createCashfreeCartOrder(data: {
  order_id: number;
  amount: number;
  customer_id: string;
  customer_email: string;
  customer_name: string;
  customer_phone: string;
}): Observable<{payment_session_id: string; order_id: string}> {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    })
  };

  return this.http.post<{payment_session_id: string; order_id: string}>(
    `${this.backendUrl}auth/cashfree/create-cart-order`,
    data, // Only sending order_id as per backend requirement
    httpOptions
  );
}
 
}
